export default "__VITE_ASSET__B8Er8Dch__"